export function useFetchLegalTextBySlug(slug: MaybeRef<string | undefined>) {
  return useQuery({
    ...queries().legalTexts.bySlug(slug),
    enabled: computed(() => !!toValue(slug)),
  });
}
